import { FormMetadata, OnlinePatientManagementContext, IFormSingleResponse } from "@ngt/opms";
import { useCallback, useContext, useMemo } from "react";
import { KeyedMutator } from "swr";
import { IConsentForm } from "../../api/dtos";

const useEConsentFormSave =  <TData extends IConsentForm = IConsentForm>(formMetadata?: FormMetadata, guid?: string, mutate?: KeyedMutator<IFormSingleResponse<TData>>) => {
    const {serviceStackClient, dtos} = useContext(OnlinePatientManagementContext);

    const formDto = useMemo(() => {
        return dtos[`${formMetadata?.name}EConsentFormPostSave`];
    }, [dtos, formMetadata])

    // @ts-ignore
    const save = useCallback(async (saveData: TData, shouldRevalidate?: boolean) => {
        if (!formDto || !guid) {
            return;
        }

        const response: IFormSingleResponse<TData> = await serviceStackClient.post(new formDto({ form: saveData, guid }))

        if (mutate) {
            const mutated = await mutate(response, shouldRevalidate ?? !!saveData.id);

            return mutated?.form;
        }

        return response?.form;
    }, [serviceStackClient, formDto, guid, mutate]);

    return save;
};

export default useEConsentFormSave;